import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { AdapterRegistry, IModel, Metamodel, SapODataLinkedService } from 'shell-models-lib';
import { Model } from 'app/model/backendmodel';
import {
    parameterizablePasswordOrAKVtoSecretBase,
    parameterizableSecretBaseToModel
} from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { ValueAdapter } from 'app/model/adapters/value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapODataLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                hostUrl: '*',
                catalogServicePath: '*',
                userName: '*',
                language: '*',
                password: 'secret',
                clientId: '*'
            },
            parameter: '*'
        }
    }
})
export class SapOdataLinkedServiceAdapter extends LinkedServiceAdapter<SapODataLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected override modelConstructor(): new () => SapODataLinkedService {
        return SapODataLinkedService;
    }

    protected override model(): IModel {
        return SapODataLinkedService.MODEL;
    }

    protected override async propertiesToResourceAsync(
        linkedService: SapODataLinkedService,
        linkedServiceResource: Model.LinkedServiceResource
    ): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.SapODataLinkedService;

        properties.type = this.model().name;
        properties.typeProperties = {
            hostUrl: this.valueToResource(linkedService, SapODataLinkedService.HOST_URL),
            catalogServicePath:
                this.valueToResource(linkedService, SapODataLinkedService.CATALOG_SERVICE_PATH) || undefined,
            userName: this.valueToResource(linkedService, SapODataLinkedService.USER_NAME),
            language: this.valueToResource(linkedService, SapODataLinkedService.LANGUAGE) || undefined,
            password: parameterizablePasswordOrAKVtoSecretBase(
                linkedService,
                SapODataLinkedService.PASSWORD,
                this.context
            ),
            clientId: this.valueToResource(linkedService, SapODataLinkedService.CLIENT_ID) || undefined
        };

        return linkedServiceResource;
    }

    protected override async propertiesToModelAsync(
        linkedServiceResource: Model.LinkedServiceResource,
        linkedService: SapODataLinkedService
    ): Promise<SapODataLinkedService> {
        const properties = linkedServiceResource.properties as Model.SapODataLinkedService;
        const typeProperties = properties.typeProperties;
        if (typeProperties != null) {
            ValueAdapter.toModel(linkedService, SapODataLinkedService.HOST_URL, typeProperties.hostUrl);
            ValueAdapter.toModel(
                linkedService,
                SapODataLinkedService.CATALOG_SERVICE_PATH,
                typeProperties.catalogServicePath
            );
            ValueAdapter.toModel(linkedService, SapODataLinkedService.USER_NAME, typeProperties.userName);
            ValueAdapter.toModel(linkedService, SapODataLinkedService.LANGUAGE, typeProperties.language);
            parameterizableSecretBaseToModel(linkedService, SapODataLinkedService.PASSWORD, typeProperties.password, this.context);
            ValueAdapter.toModel(linkedService, SapODataLinkedService.CLIENT_ID, typeProperties.clientId);
        }
        return linkedService;
    }
}
